import { WebStorageStateStore } from 'oidc-client'
import isSupported from './supported-storage'

const STORAGE_PREFIX = 'oxford-'

export default function getUserStore() {
  if (typeof window !== 'undefined') {
    const store = isSupported(window.localStorage) && window.localStorage

    return new WebStorageStateStore({ prefix: STORAGE_PREFIX, store })
  }
}
